import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { id: "familytoday-sidebar-nav" }
const _hoisted_2 = { class: "list-unstyled components" }
const _hoisted_3 = ["id", "onClick"]
const _hoisted_4 = ["id"]
const _hoisted_5 = { class: "list-unstyled sidebar-sub-column" }
const _hoisted_6 = ["href"]
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"clearfix collapse in\" id=\"assessments-nav-menu\" aria-expanded=\"true\"><ul class=\"list-unstyled sidebar-sub-column\"><div class=\"premium-badge-on-nav\"><li><a href=\"https://www.familytoday.com/coupled\">Coupled</a></li></div><div class=\"clearfix\"></div><div class=\"premium-badge-on-nav\"><li><a href=\"https://www.familytoday.com/parenteen\">Parenteen</a></li></div></ul></div>", 1)

import { toRefs } from "vue";

// Incoming props

export default /*#__PURE__*/_defineComponent({
  __name: 'Navigation',
  props: {
    sections: Array,
},
  setup(__props) {

const props = __props;



// get back prop values
const { sections } = toRefs(props);

const closeSidebar = function () {
    document
        .getElementById("familytoday-sidebar-nav")
        .classList.remove("active");
    document.getElementById("main-nav-overlay").style.display = "none";
};

const openSubMenu = function (guid) {
    const mainMenuEl = document.getElementById(guid + "-main");
    const subNavMenuEl = document.getElementById(guid + "-nav-menu");

    // Toggle index level
    mainMenuEl?.classList.toggle("collapsed");
    if (
        mainMenuEl.hasAttribute("aria-expanded") &&
        mainMenuEl.getAttribute("aria-expanded") == "true"
    ) {
        mainMenuEl.setAttribute("aria-expanded", "false");
    } else {
        mainMenuEl.setAttribute("aria-expanded", "true");
    }

    // Toggle sub menu level
    subNavMenuEl?.classList.toggle("in");
    if (
        subNavMenuEl.hasAttribute("aria-expanded") &&
        subNavMenuEl.getAttribute("aria-expanded") == "true"
    ) {
        subNavMenuEl.setAttribute("aria-expanded", "false");
    } else {
        subNavMenuEl.setAttribute("aria-expanded", "true");
    }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", {
      id: "dismiss",
      onClick: closeSidebar
    }),
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sections), (section) => {
        return (_openBlock(), _createElementBlock("li", { key: section }, [
          _createElementVNode("a", {
            id: section.Title.replace('-', '').toLowerCase() + '-main',
            "data-toggle": "collapse",
            "aria-expanded": "false",
            class: "main-sidebar-item",
            onClick: ($event: any) => (
                        openSubMenu(
                            section.Title.replace('-', '').toLowerCase()
                        )
                    )
          }, _toDisplayString(section.Title), 9, _hoisted_3),
          _createElementVNode("div", {
            class: "clearfix collapse",
            id: 
                        section.Title.replace('-', '').toLowerCase() +
                        '-nav-menu'
                    
          }, [
            _createElementVNode("ul", _hoisted_5, [
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: section.Url
                }, _toDisplayString(section.Title + " Home"), 9, _hoisted_6)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.SubSections, (subsection) => {
                return (_openBlock(), _createElementBlock("li", { key: subsection }, [
                  _createElementVNode("a", {
                    href: subsection.Url
                  }, _toDisplayString(subsection.Title), 9, _hoisted_7)
                ]))
              }), 128))
            ])
          ], 8, _hoisted_4)
        ]))
      }), 128)),
      _createElementVNode("li", null, [
        _createElementVNode("a", {
          id: "assessments-main",
          "data-toggle": "collapse",
          "aria-expanded": "true",
          class: "main-sidebar-item",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (openSubMenu('assessments')))
        }, "Assessments"),
        _hoisted_8
      ])
    ])
  ]))
}
}

})